<template lang="pug">
.monaco-editor-container(
    ref="container"
    :style="{ '--height': height + 'px' }"
    :class="{ disabled, focused }"
)
    .editor
        vue-monaco-editor(
            ref="editor"
            v-model:value="content"
            theme="vs-dark"
            :language="language === 'js' ? 'javascript' : language"
            :options="options"
            @mount="handleMount"
        )
</template>

<script>
import '@fontsource/fira-code'
// import '@fontsource/jetbrains-mono'
// import '@fontsource/monaspace-krypton';

import { VueMonacoEditor } from '@guolao/vue-monaco-editor'
import oneDarkTheme from '@/assets/monaco-themes/one-dark.json'
import githubDarkTheme from '@/assets/monaco-themes/github-dark.json'

export default {
    name: 'MonacoEditor',
    props: {
        value: {
            default: undefined
        },
        language: {
            type: String,
            required: true,
            validator(value) {
                // The value must match one of these strings
                return ['html', 'twig', 'js', 'json', 'javascript', 'css'].includes(value)
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            content: this.value,
            editor: null,
            monaco: null,
            height: 138,
            focused: false,
        }
    },
    components: {
        VueMonacoEditor,
    },
    watch: {
        value(value) {
            if (value !== this.content) {
                this.content = value;
            }

            // if (!this.disabled) {
            //     this.$emit('input', value);
            // }
        },
        // disabled(disabled) {
        //     if (disabled) {
        //         this.editor.updateOptions({
        //             readOnly: true,
        //             selectionHighlight: false,
        //             occurrencesHighlight: false,
        //             renderLineHighlight: 'none',
        //         });
        //     } else {
        //         this.editor.updateOptions({
        //             readOnly: false,
        //             selectionHighlight: true,
        //             occurrencesHighlight: true,
        //             renderLineHighlight: 'all',
        //         });
        //     }
        // }
    },
    computed: {
        options() {
            return {
                // height: this.height,
                fontSize: 14,
                // fontFamily: 'Jetbrains-Mono',
                fontFamily: 'Fira Code',
                fontLigatures: true,
                automaticLayout: true,
                formatOnType: true,
                formatOnPaste: true,
                scrollBeyondLastLine: false,
                readOnly: this.readOnly || this.disabled,
                domReadOnly: this.readOnly || this.disabled,
                renderIndentGuides: !this.disabled,
                selectionHighlight: !this.disabled,
                occurrencesHighlight: !this.disabled,
                renderLineHighlight: (this.readOnly || this.disabled) ? 'none' : 'all',
                // colorDecorators: !this.disabled,
                colorDecorators: false,
                colorDecoratorsActivatedOn: 'click',
                renderLineHighlightOnlyWhenFocus: true,
                wordWrap: 'on',
                wrappingStrategy: 'advanced',
                minimap: {
                    enabled: !this.disabled,
                },
                overviewRulerLanes: 0.
            }
        }
    },
    methods: {
        handleBeforeMount(monaco) {
        },
        handleMount(editor, monaco) {
            this.editor = editor;
            this.monaco = monaco;

            this.updateHeight();

            // this.monaco.editor.defineTheme('github-dark', githubDarkTheme)
            // this.monaco.editor.setTheme('github-dark')

            this.monaco.editor.defineTheme('one-dark', oneDarkTheme)
            this.monaco.editor.setTheme('one-dark')

            this.editor.onDidChangeModelContent(() => {
                this.$emit('input', this.editor.getValue());
            });

            this.editor.onDidContentSizeChange(this.updateHeight);

            this.editor.onDidFocusEditorWidget(() => {
                this.focused = true;
            });

            this.editor.onDidBlurEditorWidget(() => {
                this.focused = false;
            });

            // const observer = new ResizeObserver(this.handleResize);
            // observer.observe(this.$refs.container);
        },
        updateHeight() {
            const contentHeight = this.editor.getContentHeight();
            this.height = contentHeight;
            // this.editor.layout({ height: contentHeight });
        },
        handleResize() {
            // this.editor.layout()
        },
    },
}
</script>

<style lang="sass" scoped>
.monaco-editor-container
    position: relative
    resize: vertical
    overflow: auto
    border-radius: 6px
    isolation: isolate
    min-height: 138px
    height: 26rem
    max-height: var(--height)
    &.focused::v-deep
        z-index: 5
    // &.focused
    //     overflow: visible
    &.disabled
        filter: contrast(0.8) brightness(1.2) saturate(40%)
        // opacity: 0.8
    .editor
        position: absolute
        inset: 0
</style>
